import { toast } from 'react-toastify';
import { i18n } from '../translate/i18n';
import { isString } from 'lodash';

/**
 * Exibe feedback de sucesso/info/aviso em toast (react-toastify). Espelha toastError.
 * Visual e opções padrão vêm do ToastContainer.
 *
 * Padrão do projeto:
 * - Para sucesso de operação (criar/editar/excluir/salvar): usar toastSuccess('toastSuccess.<chave>').
 * - Aceita chave i18n (traduz se existir) ou texto cru (fallback).
 * - Para interpolação, passar { i18nOptions: { ... } }; demais opções vão para o toast.
 * - Erros de API/backend continuam em toastError.
 *
 * @param {string} msgOrKey Chave i18n (ex: 'toastSuccess.created') ou texto pronto.
 * @param {object} [options] Opções do toast + { i18nOptions } para interpolação da tradução.
 */
const resolveMessage = (msgOrKey, i18nOptions) => {
  if (!isString(msgOrKey)) return msgOrKey;
  if (i18n.exists(msgOrKey)) return i18n.t(msgOrKey, i18nOptions);
  return msgOrKey;
};

const buildToast =
  (variant) =>
  (msgOrKey, options = {}) => {
    const { i18nOptions, ...toastOptions } = options;
    return toast[variant](resolveMessage(msgOrKey, i18nOptions), toastOptions);
  };

export const toastSuccess = buildToast('success');
export const toastInfo = buildToast('info');
export const toastWarning = buildToast('warning');

export default toastSuccess;
